export default __webpack_public_path__ + "static/about-jelllow-star-min-b051d67cbd796ba2f8be5547743cd6c7.png";